/* ============================================================
   DUSK & RELIC — welcome-offer popup (no deps, namespaced)
   localStorage `dnr:welcome` (persists across sessions):
     ''        not subscribed → auto-open after data-delay seconds
     'pending' form submitted, waiting for Shopify's redirect back
     'joined'  subscribed → popup and tab never show again, ever
   sessionStorage `dnr:welcome:closed` (this session only):
     '1'       dismissed via ✕ → no auto-open until a new session;
               the left-edge tab stays available to reopen it.
   On success the code is also saved to the cart session via
   /discount/<code>, so checkout applies it without typing.
   ============================================================ */
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') { fn(); }
    else { document.addEventListener('DOMContentLoaded', fn); }
  }

  ready(function () {
    var root = document.querySelector('[data-dnr-wpop]');
    var tab = document.querySelector('[data-dnr-wpop-tab]');
    if (!root) { if (tab) tab.hidden = true; return; }

    // escape filtered/sticky ancestors so fixed positioning spans the viewport
    if (root.parentElement !== document.body) document.body.appendChild(root);
    if (tab && tab.parentElement !== document.body) document.body.appendChild(tab);

    var KEY = 'dnr:welcome';
    var SKEY = 'dnr:welcome:closed';
    function st() { try { return localStorage.getItem(KEY) || ''; } catch (e) { return ''; } }
    function set(v) { try { localStorage.setItem(KEY, v); } catch (e) {} }
    function closedThisSession() { try { return sessionStorage.getItem(SKEY) === '1'; } catch (e) { return false; } }
    function markClosed() { try { sessionStorage.setItem(SKEY, '1'); } catch (e) {} }

    var code = root.getAttribute('data-code') || '';
    var joined = !!root.querySelector('[data-dnr-wpop-joined]');
    var hasError = !!root.querySelector('[data-dnr-wpop-error]');

    function showTab(show) { if (tab) tab.hidden = !show; }
    function open() {
      root.hidden = false;
      document.body.style.overflow = 'hidden';
      showTab(false);
      var input = root.querySelector('input[type="email"]');
      if (input) setTimeout(function () { input.focus(); }, 80);
    }
    function close() {
      root.hidden = true;
      document.body.style.overflow = '';
      if (st() !== 'joined') { markClosed(); showTab(true); }
    }
    function applyCode() {
      if (!code) return;
      // checkout session cookie — works even before a cart exists
      fetch('/discount/' + encodeURIComponent(code)).catch(function () {});
      // also attach the code to the cart itself so the drawer and cart page
      // render the discounted totals right away (May-2025 Cart AJAX API)
      fetch(((window.routes && window.routes.cart_update_url) || '/cart/update') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ discount: code })
      }).then(function () {
        window.dispatchEvent(new CustomEvent('dnr:cart:refresh'));
      }).catch(function () {});
    }

    root.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      if (e.target.closest('[data-dnr-wpop-close]')) { close(); return; }
      var copy = e.target.closest('[data-dnr-wpop-copy]');
      if (copy && navigator.clipboard) {
        var orig = copy.textContent;
        navigator.clipboard.writeText(code).then(function () {
          copy.textContent = copy.getAttribute('data-copied-label') || 'Copied';
          setTimeout(function () { copy.textContent = orig; }, 1600);
        }).catch(function () {});
      }
    });
    if (tab) tab.addEventListener('click', open);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !root.hidden) close();
    });
    var form = root.querySelector('form');
    if (form) form.addEventListener('submit', function () { set('pending'); });

    if (joined) {
      // back from a successful post — celebrate once, then stay quiet forever
      applyCode();
      var already = st() === 'joined';
      set('joined');
      if (!already) open();
      return;
    }
    if (hasError) {
      // Shopify bounced the email — reopen so the message is visible
      if (st() === 'pending') set('');
      open();
      return;
    }
    var s = st();
    if (s === 'joined') return;
    if (s === 'closed') {
      // legacy value from the earlier permanent-dismiss build → migrate to
      // the session-scoped model so a future session can auto-open again
      set('');
      markClosed();
      s = '';
    }
    if (closedThisSession()) { showTab(true); return; }
    var delay = parseInt(root.getAttribute('data-delay') || '30', 10);
    if (isNaN(delay) || delay < 0) delay = 0;
    setTimeout(function () {
      if (st() === 'joined' || closedThisSession() || !root.hidden) return;
      open();
    }, delay * 1000);

    // theme editor: selecting the section opens the popup for styling
    var sid = root.getAttribute('data-section-id');
    document.addEventListener('shopify:section:select', function (e) {
      if (e.detail && e.detail.sectionId === sid) open();
    });
    document.addEventListener('shopify:section:deselect', function (e) {
      if (e.detail && e.detail.sectionId === sid) close();
    });
  });
})();
